import {defineMessages} from 'react-intl';

export default defineMessages({
	myAccount: {
		id: 'serviceMenuItem.myAccount',
		defaultMessage: 'My Account',
	},
	logIn: {
		id: 'serviceMenuItem.logIn',
		defaultMessage: 'Login',
	},
});
